$(document).on('click', '.spMenuBt', function () {
	$('.nav').fadeToggle();
	$(this).toggleClass('active');
  });

  $(document).on('click', '.close', function () {
	$('.nav').fadeToggle();
	$('.spMenuBt').removeClass('active');
  });
  
  $(document).on('click', '.nav a', function () {
	$('.nav').fadeOut();
	$('.spMenuBt').removeClass('active');
  });


  $(function() {
	// ページ読み込み開始時刻
	const startTime = new Date().getTime();
  
	// すべてのリソース読み込み完了
	$(window).on('load', function() {
	  const endTime = new Date().getTime();
	  const loadingTime = endTime - startTime;
  
	  // 最低3秒はローディング画面を表示
	  const minDisplayTime = 3000;
	  const remainingTime = (loadingTime < minDisplayTime)
		? (minDisplayTime - loadingTime)
		: 0;
  
	  // 残り時間を待機
	  setTimeout(function() {
		// (1) 「ZZZZ」テキストを先に消す
		$('.loading-message').fadeOut(800, function() {
		  // (2) テキスト消えた後、ローディング画面を消す
		  $('#loading-screen').fadeOut(800, function() {
			// ローディング画面削除
			$(this).remove();
  
			// メインコンテンツを表示 (display: none → block)
			$('.content').css('display', 'block');
  
			// ぼかしを戻すなどの演出（必要なら）
			setTimeout(function() {
			  $('.content').css('filter', 'blur(0)');
			}, 300);
		  });
		});
	  }, remainingTime);
	});
  });





(() => {
  // ▼ ふわっとさせたい要素の種類
  //   必要なら main h2, main p みたいに絞ることもできる
  const TARGET_SELECTOR = 'h2, h3, h4, h5, p, li, figure, table';

  // ▼ 必要なCSSをJS側から注入
  const css = `
    /* 初期状態：ちょっと下＋透明 */
    .js-scroll-fade {
      opacity: 0;
      transform: translateY(20px);
      transition:
        opacity 0.6s ease-out,
        transform 0.6s ease-out;
      will-change: opacity, transform;
    }
    /* 画面内に入ったら表示 */
    .js-scroll-fade.is-inview {
      opacity: 1;
      transform: translateY(0);
    }
  `;
  const styleId = 'scroll-fade-style';
  if (!document.getElementById(styleId)) {
    const tag = document.createElement('style');
    tag.id = styleId;
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function initScrollFade() {
    const targets = Array.from(document.querySelectorAll(TARGET_SELECTOR));
    if (!targets.length) return;

    // IntersectionObserver 非対応ブラウザは全部表示でフォールバック
    if (!('IntersectionObserver' in window)) {
      targets.forEach(el => {
        el.classList.add('js-scroll-fade', 'is-inview');
      });
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.classList.add('is-inview');
        io.unobserve(el); // 一度表示したら監視解除（何度もアニメしない）
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px', // 下10%手前で発火
      threshold: 0.1,
    });

    targets.forEach(el => {
      el.classList.add('js-scroll-fade');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollFade);
  } else {
    initScrollFade();
  }
})();